import { Col, Form, Row, Select } from 'antd';
import { FormComponentProps } from "antd/lib/form";
import React from 'react';

const FormItem = Form.Item;
const Option = Select.Option;

interface IProps extends FormComponentProps {
    paymentMethod: string;
}

class ChangePaymentMethodForm extends React.Component<IProps>{
    public render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout="vertical">
                <Row gutter={48}>
                    <Col span={8}>
                        <FormItem label='Current Method'>
                            {`${this.props.paymentMethod === 'cc' ? 'Credit Card' : 'Invoice'}`}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label={'New Method'}>
                            {getFieldDecorator('newPaymentMethod', {
                                initialValue: '',
                                rules: [
                                    { validator: this.validateMethod }
                                ],
                            })(
                                <Select>
                                    <Option value={''}>Select Payment Method</Option>
                                    <Option value={'cc'}>Credit Card</Option>
                                    <Option value={'invoice'}>Invoice</Option>
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }

    private validateMethod = (rule: any, value: any, callback: any) => {
        // Validates that the input isn't the default or the same as their current
        if (!value){
            callback('Please select a payment method')
        } else if (value === this.props.paymentMethod) {
            callback('Customer is already on the selected payment method')
        } else {
            callback();
        }
    }
}

export default Form.create<IProps>()(ChangePaymentMethodForm);
